/* eslint-disable react/prop-types,react/prop-types */
import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../utils/withRouter';
import {loadRuns, UpdateFilter, setRunOrder} from '../../actions/runActions';
import Runs from '../Runs/Runs';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';
import {PickupNoteSummary} from "../Pickups/PickupNoteSummary";
import {Aux, BASE_URL, isNullEmptyOrWhitespace, ROLE_SuperUser} from '../../constants';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { apiRequest } from '../../utils/request';
import {getCollectionAction} from "../../utils/collectionTypes";


const RunItem = SortableElement(({run, pathSegment, totalRunCount, currentRunIndex}) => {
  return (
    <div>    
    
      <div className="row" key={run.id}>
        <div className="col-md-8">
          <div className="card" key={run.regionsVisited}>
            <div className="card-block">
              <h5 className="card-title">
                {run.isComplete && <span className="badge badge-success">Run Complete</span>}
                {!run.isComplete && <span className="badge badge-warning">Run Incomplete</span>}
                { run.dateModified != '0001-01-01T00:00:00' && <span className="text-muted pull-right" style={{fontSize:'small'}}><i className="fa fa-save"/>&nbsp;{moment(run.dateModified).format('ddd, Do, LT')}</span> }
              </h5>
              <h6>{run.runDate}</h6>
              <h6>Run {currentRunIndex+1} of {totalRunCount}</h6>              
              <h4>{run.regionsVisited} - {run.truckName}</h4>
              <h6><strong>Driver:</strong> {run.driverFullName}</h6>
              <p className="card-text"><i className="fa fa-shopping-cart" />&nbsp; { `${parseFloat(run.totalLitres).toFixed(0)} L to be ${getCollectionAction(run.truckCollectionTypeCode)}`}</p>
              <p className="card-text"><i className="fa fa-battery-full" />&nbsp; { `${parseFloat(run.totalEstimatedLitresPickedUp).toFixed(2)} L ${getCollectionAction(run.truckCollectionTypeCode)}`}</p>
              <p className="card-text"><i className="fa fa-tachometer" />&nbsp; { `${run.pickupsComplete}/${run.pickupsToComplete}`} locations complete</p>
              { (run.pickupsToComplete-run.pickupsComplete == 0) && run.isBaseCheckedIn && !run.isBaseCheckedOut && <p className="card-text text-danger"><i className="fa fa-warning" /> Must check out of final location</p> }
              <div>
                {run.pickups.map(p => <PickupNoteSummary key={p.id} pickup={p} />)}
              </div>            
              {run.lastPickupDate && <p>
                <span className="font-weight-bold text-primary">Last checkin: </span>
                <span>{moment(run.lastPickupDate).format('ddd, Do, LT')}</span>
              </p>}
            </div>
          </div>
        </div>
      </div>
  
  </div>
    );
});

const SortableRuns = SortableContainer(({runs, loadRuns, userName,  isAdmin, hideReload, pathSegment}) => {
  if(!runs || !runs.items || runs.items.length == 0 )
  {
    return (
        <div>
         No runs found
        </div>
    );
  }
  return (
    <div>
      <div className="row">
      <div className="col-md-12">
        {runs.loaded &&  <h5>
          { userName != '' && <strong>{userName.charAt(0).toUpperCase() + userName.slice(1)}, you have {runs.items.length} run(s)&nbsp;&nbsp;</strong>}
          { !hideReload && <button type="button" className="btn btn-primary" onClick={loadRuns}><i className="fa fa-refresh" />&nbsp;Reload runs</button> }
          { userName == '' && <span>Found {runs.items.length} runs</span> }
        </h5>}
        {!runs.loaded && <h5>
          <p>Loading runs... <i className="fa fa-cog fa-spin fa-2x" /></p>
        </h5>}
      </div>
    </div>        
    {runs.items.map((run, index) =>
      {
      return(
            <RunItem
            key={`run-${index}`}
            index={index}
            run={run}          
            pathSegment={pathSegment}
            totalRunCount={runs.items.length}
            currentRunIndex={index}
          />
          );}
    )}  
    </div>
  );
});    
  

class AllRunsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.loadRuns = this.loadRuns.bind(this);
    this.state = {
      runs: {...props.searchRuns.items} ,
      hideSortableRuns : true,
      // isComplete: props.isComplete,
      // dateFrom: props.dateFrom,
      // dateTo: props.dateTo,
      typesOptions: [
        {
          label: "Collection",
          value: "Collection",
        },
        {
          label: "Fresh Oil",
          value: "Fresh Oil",
        }
      ]
    };
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnChangeDate = this.handleOnChangeDate.bind(this);
    this.loadRuns = this.loadRuns.bind(this);
    this.resetForm = this.resetForm.bind(this);    
    this.onSortEnd = this.onSortEnd.bind(this); 
    this.setRunOrder = this.setRunOrder.bind(this);    
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    let runs = {...this.state.runs};
    let runsItems = arrayMove([...runs.items], oldIndex, newIndex);      

    for(let i = 0; i < runsItems.length; i++){
      runsItems[i] = {...runsItems[i], runOrder: parseInt(i)+1};
    }
   
    runs.items = runsItems;    
    this.setState({ runs });
  };

  loadRuns(e) {
    if(e){
      e.preventDefault();
    }
    let {isComplete, dateFrom, dateTo, selectedDriverId, selectedTypes} = this.props.searchRuns;
    this.props.dispatch(loadRuns(true, isComplete, dateFrom, dateTo, selectedDriverId, selectedTypes));

    // if(selectedDriverId == "-1")
    // {
    //   this.setState({ hideSortableRuns: true });
    // }
    // else
    // {
    //   this.setState({ hideSortableRuns: false});
    // }
  }
  componentDidMount(){
    if(!this.props.hasRunId || !this.props.children){
      this.loadRuns();
    }    
    
    if(this.refs.allRuns){
      window.scrollTo(0, 0);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {    
    if(this.props.searchRuns && prevProps.searchRuns && JSON.stringify(this.props.searchRuns) !== JSON.stringify(prevProps.searchRuns)){      
      this.setState({ runs: this.props.searchRuns });
    }
  }

  handleOnChange(e) {
    e.preventDefault();
    let {isComplete, dateFrom, dateTo, selectedDriverId, selectedTypes} = this.props.searchRuns;
    let x = {isComplete, dateFrom, dateTo, selectedDriverId, selectedTypes};
    x[`${e.target.name}`] = e.target.value;
    //this.setState(x);
    this.props.dispatch(UpdateFilter(x));      
  }

  handleSelectChange(value = []){
    let {isComplete, dateFrom, dateTo, selectedDriverId} = this.props.searchRuns;
    let x = {isComplete, dateFrom, dateTo, selectedDriverId};
    x.selectedTypes = value.map(x => x.value);
    this.props.dispatch(UpdateFilter(x));  
  }

  handleOnChangeDate(date, name) {
    let {isComplete, dateFrom, dateTo, selectedDriverId} = this.props.searchRuns;
    let x = {isComplete, dateFrom, dateTo, selectedDriverId};
    x[`${name}`] = date.format('YYYY-MM-DD');
    //this.setState(x);
    this.props.dispatch(UpdateFilter(x));
  }

  resetForm(){
    this.setState({hideSortableRuns: true}, ()=>{
      this.props.dispatch(UpdateFilter());  
    });
    
    
    /*console.log(this.state.runs);
    console.log(this.props.searchRuns);*/
/*
    this.setState({
      isComplete: 0,
      dateFrom: moment(new Date()).add(-7, 'days').format('YYYY-MM-DD'),
      dateTo: moment(new Date()).format('YYYY-MM-DD'),
    });*/
  }

  setRunOrder(e){
    if(e){
      e.preventDefault();
    }        
    this.setState({hideSortableRuns: true},  ()=> {
      this.props.dispatch(setRunOrder(this.state.runs.items, () => {
        this.loadRuns();
      }));
    });
  }


  render() {
    if(this.props.children){
      return (<div>{this.props.children}</div>);
    }
    else {
      let {isComplete, dateFrom, dateTo, selectedDriverId, items, selectedTypes} = this.props.searchRuns;
      let {hideSortableRuns, typesOptions}  = this.state;

      return (
        <div ref="allRuns">

          <form className={'form-inline'} onSubmit={this.loadRuns} style={{marginBottom: '10px'}}>
            <div className="form-group">
              <label className={'control-label col-sm-2'}>From: </label>
              <div className="col-sm-10">
              <DatePicker
                onChange={(date) => this.handleOnChangeDate(date, 'dateFrom')}
                value={dateFrom}
                openToDate={moment(dateFrom)}
                placeholderText="Date From"
                locale="en-au"
                readOnly={false}
                popperPlacement="bottom-end"
                popperModifiers={{
                  offset: {
                    enabled: true,
                    offset: '5px, 10px'
                  },
                  preventOverflow: {
                    enabled: true,
                    escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                    boundariesElement: 'viewport'
                  }
                }}
                className="form-control"
              />
              </div>
            </div>
            <div className="form-group">
              <label className={'control-label col-sm-2'}>To: </label>
              <div className="col-sm-10">
              <DatePicker
                onChange={(date) => this.handleOnChangeDate(date, 'dateTo')}
                value={dateTo}
                openToDate={moment(dateTo)}
                placeholderText="Date To"
                locale="en-au"
                readOnly={false}
                popperPlacement="bottom-end"
                popperModifiers={{
                  offset: {
                    enabled: true,
                    offset: '5px, 10px'
                  },
                  preventOverflow: {
                    enabled: true,
                    escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                    boundariesElement: 'viewport'
                  }
                }}
                className="form-control"
              />
              </div>
            </div>
            <div className="form-group">
              <label className={'control-label col-sm-2'}>Status: </label>
              <div className="col-sm-10">
              <select className="form-control custom-select"
                      value={isComplete}
                      onChange={this.handleOnChange}
                      name="isComplete">
                <option value="-1">All</option>                        
                <option value="0">Incomplete</option>
                <option value="1">Complete</option>                
              </select>
              </div>
            </div>
            
            <div className="form-group">
            <label className={'control-label col-sm-2'}>Driver: </label>
              <div className="col-sm-10">
                <select className="form-control custom-select"
                        value= {selectedDriverId}
                        onChange={this.handleOnChange}
                        name="selectedDriverId">
                  <option value="-1" key="-1">All</option>
                  { this.props.drivers.items.map(d => (<option value={d.id} key={d.id}>{d.fullName}</option>)) }
                </select>
              </div>
            </div>
            <div className='form-group mt-2'>
              <label className={'form-control-label col-sm-2'} htmlFor='selectedTypes'>Type: </label>
              <div className='col-sm-10'>
                <Select
                  style={{
                    minWidth: '200px'
                  }}
                  name="selectedTypes"
                  clearable
                  multi
                  options={typesOptions}
                  value={selectedTypes}
                  onChange={v => this.handleSelectChange(v)}
                />
              </div>
            </div>
          </form>

          <div className="row mt-2 mb-2">
            <div className="col-12">
              <button className="btn btn-primary" onClick={this.loadRuns}>Search</button>
              <button className="btn btn-default ml-2" onClick={this.resetForm}>Reset</button>
              { (selectedDriverId > 0 && hideSortableRuns && items.length > 0) ? 
                  <button className="btn btn-secondary ml-2" onClick={()=>this.setState({hideSortableRuns: false})}>Order Driver Runs</button> :
                  (!hideSortableRuns && selectedDriverId > 0 && 
                      <Aux>
                        <button className="btn btn-success ml-2" onClick={this.setRunOrder}>Complete Save Order</button>
                        <button className="btn btn-warning ml-2" onClick={()=>this.setState({hideSortableRuns: true}, this.loadRuns)}>Cancel Order</button>
                      </Aux>
                    ) }                
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
             {
               this.state.hideSortableRuns && 
               <Runs
                runs={this.props.searchRuns}
                loadRuns={this.loadRuns}
                userName=""
                isAdmin={this.props.account.user.hasRole(ROLE_SuperUser)}
                hideReload
                pathSegment={'search'}
              /> 
             }

             {
              (!this.state.hideSortableRuns) && 
              <SortableRuns
                runs={this.state.runs}                
                loadRuns={this.loadRuns}
                userName=""
                isAdmin={this.props.account.user.hasRole(ROLE_SuperUser)}
                hideReload
                pathSegment={'search'}
                onSortEnd={this.onSortEnd}
              />
             }
            </div>
          </div>
        </div>);
    }
  }
}

AllRunsPage.propTypes = {
  searchRuns: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  drivers: PropTypes.object.isRequired,
};
  
function mapStateToProps(state, ownProps){
  let {dateFrom, dateTo} = state.searchRuns;

  let from =  moment(dateFrom);
  let to = moment(dateTo);

  let runs = state.searchRuns.items.filter(x => {
    let runDate = moment(x.timeStart);
    return runDate.isSameOrAfter(from) && runDate.isSameOrBefore(to);
  });

  let newState = {...state.searchRuns, items: [...runs]};

  return {
    searchRuns: newState,//state.searchRuns,
    account: state.account,
    hasRunId: ownProps.routeParams && ownProps.routeParams.id ? true : false,
    drivers: state.drivers,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AllRunsPage));
